module.exports = __webpack_public_path__ + "assets/img/JD_banner.5e6f4d1d.jpg";